import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environment';
import type { FishingSpotCreateOrUpdateRequest, FishingSpotDetail, FishingSpotListItem } from '@models/fishing-spots';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CrmFishingSpotsService {
  private readonly http = inject(HttpClient);

  private url(waterId: number): string {
    return `${environment.apiUrl}/api/crm/waters/${waterId}/fishing-spots`;
  }

  getSpots(waterId: number): Observable<FishingSpotListItem[]> {
    return this.http.get<FishingSpotListItem[]>(this.url(waterId));
  }

  getSpot(waterId: number, id: number): Observable<FishingSpotDetail> {
    return this.http.get<FishingSpotDetail>(`${this.url(waterId)}/${id}`);
  }

  createSpot(waterId: number, dto: FishingSpotCreateOrUpdateRequest): Observable<FishingSpotDetail> {
    return this.http.post<FishingSpotDetail>(this.url(waterId), dto);
  }

  updateSpot(waterId: number, id: number, dto: FishingSpotCreateOrUpdateRequest): Observable<FishingSpotDetail> {
    return this.http.put<FishingSpotDetail>(`${this.url(waterId)}/${id}`, dto);
  }

  deleteSpot(waterId: number, id: number): Observable<void> {
    return this.http.delete<void>(`${this.url(waterId)}/${id}`);
  }

  uploadImage(waterId: number, id: number, file: File): Observable<FishingSpotDetail> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<FishingSpotDetail>(`${this.url(waterId)}/${id}/image`, formData);
  }
}
